<template>
	<div class="collect-page">

		<!-- ===== 主卡片 ===== -->
		<div class="main-card animate__animated  ">

			<!-- 标题 -->
			<div class="card-title-row">
				<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30871_7042/42.svg')"></el-image>
				<h3 class="title-text">{{$t('myCollect.t1')}}</h3>
			</div>

			<!-- 商品列表（flex-wrap 5列） -->
			<div class="product-grid">
				<div
					v-for="(item, idx) in collectList"
					:key="item.id || idx"
					class="product-card"
					@click="goToDetail(item)">

					<!-- 商品图 -->
					<el-image class="prod-img" :src="item.picUrl" :preview-src-list="[item.picUrl]" fit="cover"></el-image>

					<!-- 平台标签 -->
					<div class="prod-tag-row">
						<div class="product-tag" :class="'tag-' + channelTypeMap[item.channelType]">{{ channelLabelMap[item.channelType] }}</div>
						<el-image class="shop-avatar" :src="require('@/static/CodeBuddyAssets/30871_7042/28.svg')"></el-image>
						<span class="shop-name">{{ item.shopName || $t('myCollect.t2') }}</span>
						<el-image class="more-icon" :src="require('@/static/CodeBuddyAssets/30871_7042/29.svg')"></el-image>
					</div>

					<!-- 商品名称 -->
					<p class="prod-name line1">{{ item.name || '--' }}</p>

					<!-- 价格与销量 -->
					<div class="prod-footer f-bct">
						<div class="prod-price">
							<span class="price-symbol">￥</span>
							<span class="price-number">{{ item.price || '0' }}</span>
						</div>
						<div class="f-ct">
							<span class="prod-sales">{{ $t('shopCat.t1', { count: item.salesText || '0' }) }}</span>
							<el-image class="fav-icon" :src="require('@/static/CodeBuddyAssets/30871_7042/31.svg')" @click.native.stop="cancelCollect(item, idx)"></el-image>
						</div>
					</div>
					
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { collectList, goodsCollect } from "/src/api/api.js"
export default {
	name: 'MyCollect',
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			total: 0,
			collectList: [],
			loading: false,
			channelTypeMap: {
				1: 'blue',
				2: 'red',
				3: 'orange',
				4: 'orange',
			},
		}
	},
	computed: {
		channelLabelMap() {
			return {
				1: this.$t('shopCar.t4'),
				2: '1688',
				3: this.$t('shopIndex.t16'),
				4: this.$t('shopIndex.t15'),
			}
		}
	},
	mounted() {
		this.loadCollectList()
	},
	methods: {
		// 获取收藏列表
		async loadCollectList() {
			this.loading = true
			const res = await collectList({
				page: this.currentPage,
				pageSize: this.pageSize,
			})
			this.loading = false
			if (res.code == 200) {
				this.collectList = res.rows || []
				this.total = res.total || 0
			} else {
				this.Tips(res.msg, 'error')
			}
		},
		// 取消收藏
		async cancelCollect(item, idx) {
			const res = await goodsCollect({
				goodsId: item.dataId,
				action:0,
				channelType:item.channelType,
			})
			if (res.code == 200) {
				this.Tips(res.msg || this.$t('myCollect.t3'))
				this.collectList.splice(idx, 1)
				if (this.total > 0) this.total--
			} else {
				this.Tips(res.msg || this.$t('myCollect.t4'), 'error')
			}
		},
		// 分页切换
		handleCurrentChange(page) {
			this.currentPage = page
			this.loadCollectList()
		},
		goToDetail(item) {
			// 跳转商品详情
			
		},
	},
}
</script>

<style lang="scss" scoped>
.collect-page {
	width: 100%;
	box-sizing: border-box;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 22px;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.crumb-text {
	font-size: 16px;
	color: #666;
	font-weight: 400;
	margin-left: 8px;
}
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	span {
		font-size: 16px;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 8px;
		height: 12px;
		margin-left: 6px;
	}
}

/* ===================================================================
   主卡片 (1596×860px)
   =================================================================== */
.main-card {
	width: 1596px;
	background: #fff;
	border-radius: 12px;
	padding: 32px 32px 40px;
	box-sizing: border-box;
	margin-top: 24px;
}

/* ---- 标题 ---- */
.card-title-row {
	display: flex;
	align-items: center;
	height: 28px;
	margin-bottom: 28px;
}
.title-icon {
	width: 8px;
	height: 18px;
	flex-shrink: 0;
}
.title-text {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	margin-left: 4px;
}

/* ===================================================================
   商品列表（flex-wrap 5列）
   =================================================================== */
.product-grid {
	display: flex;
	flex-wrap: wrap;
}

/* ---- 商品卡片 (238×352px) ---- */
.product-card {
	// width: 238px;
	padding: 12px 12px;
	// height: 352px;
	flex-shrink: 0;
	margin-right: 24px;
	margin-bottom: 32px;
	cursor: pointer;
	position: relative;
	transition: box-shadow 0.3s;
	border-radius: 10px;
	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
	}
}
.product-card:nth-child(5n) {
	margin-right: 0;
}

/* ---- 商品图片 ---- */
.prod-img {
	width: 238px;
	height: 238px;
	border-radius: 10px;
	display: block;
	cursor: zoom-in;
}

/* ---- 平台标签 + 店铺信息行 ---- */
.prod-tag-row {
	display: flex;
	align-items: center;
	margin-top: 12px;
	padding: 0 4px;
}
.product-tag {
	// position: absolute;
	// top: 251px;
	// left: 4px;
	display: inline-block;
	border-radius: 4px;
	font-size: 12px;
	text-align: center;
	font-weight: 400;
	padding: 0 4px;
	line-height: normal;
}
.tag-orange {
	border: 1px solid #FF7120;
	background: #FFF5E9;
	color: #FF7120;
}
.tag-red {
	border: 1px solid #FC3C3C;
	background: #FFE9E9;
	color: #FC3C3C;
}
.tag-blue {
	border: 1px solid #0096FF;
	background: #E9F5FF;
	color: #0096FF;
}

.shop-info {
	display: flex;
	align-items: center;
	margin-left: 4px;
	flex: 1;
}
.shop-avatar {
	width: 18px;
	height: 18px;
	margin-left: 4px;
	margin-right: 6px;
}
.shop-name {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.more-icon {
	width: 14px;
	height: 14px;
	flex-shrink: 0;
	margin-left: 4px;
}

/* ---- 商品名称 ---- */
.prod-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	width: 238px;
	// height: 38px;
	padding: 0 4px;
	margin-top: 4px;
	line-height: 22px;
	font-weight: bold;
}
.prod-name2 {
	margin-top: 0;
}

/* ---- 价格与销量 ---- */
.prod-footer {
	display: flex;
	align-items: center;
	margin-top: 4px;
	padding: 0 4px;
}
.prod-price {
	white-space: nowrap;
}
.price-symbol {
	font-size: 12px;
	font-weight: 500;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}
.price-number {
	font-size: 18px;
	font-weight: 600;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}
.prod-sales {
	font-size: 12px;
	color: #999;
	font-weight: 400;
	margin-left: auto;
	white-space: nowrap;
}

/* ---- 收藏图标 ---- */
.fav-icon-wrap {
	position: absolute;
	bottom: 0;
	right: 0;
	width: 26px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.fav-icon {
	width: 18px;
	height: 18px;
	margin-left: 8px;
}

/* ===================================================================
   分页
   =================================================================== */
.pagination-wrap {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #0096FF;
}
.pagination-wrap ::v-deep .el-pagination.is-background .el-pager li:hover {
	color: #0096FF;
}
</style>
